import { z } from "zod";

/**
 * Schema for a select option (organization or role)
 */
export const selectOptionSchema = z.object({
  label: z.string().min(1),
  value: z.union([z.number(), z.string()]),
  data: z.any().optional(),
});

/**
 * Schema for a single affiliation entry (organization + role)
 */
export const affiliationEntryField = z.object({
  organization: selectOptionSchema,
  role: selectOptionSchema,
});

/**
 * Schema for affiliations array field
 */
export const affiliationsField = z.array(affiliationEntryField);
